import { render, staticRenderFns } from "./submit-form.vue?vue&type=template&id=21e35696&scoped=true&"
import script from "./submit-form.vue?vue&type=script&lang=js&"
export * from "./submit-form.vue?vue&type=script&lang=js&"
import style0 from "./submit-form.vue?vue&type=style&index=0&id=21e35696&prod&lang=scss&scoped=true&"
import style1 from "./submit-form.vue?vue&type=style&index=1&id=21e35696&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e35696",
  null
  
)

export default component.exports